type BadgeProps = {
  text: string;
};

export const Badge = ({ text }: BadgeProps) => {
  return (
    <span className="border border-black rounded-full bg-yellow-400 px-3 py-1 text-black text-xs font-bold">
      {text}
    </span>
  );
};
